// utils/api.js
import axios from "axios";
const API = "https://course-selling-backend-2-rr1n.onrender.com";

const api = axios.create({
  baseURL: `${API}/api`,  // 👈 ab sahi template literal
});

// ✅ Har request me token bhejne ke liye
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-auth-token"] = token; // backend auth middleware yahi expect karta hai
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
